// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"0":"81f09a27","202":"0a5f5b73","274":"8ca5e8a0","760":"1458bb73","882":"effbd77b"}[chunkId] + ".chunk.js";
};